<template>
  <div>
    <div>
      <div class="row my-4 mx-1 justify-content-center">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
          <div class="background-white">
            <div class="title">
              <div class="position">
                {{ $t("Système de déstratification d’air") }} 
              </div>
            </div>
          </div>
          
          <form @submit.prevent="systeme_destratification_airAdd">
            <div class="center mt-3">



 <b-form-group label="Type de local">
      <b-form-select
        v-model="systeme_destratification_airData.local_type"
        :options="localOptions"
        placeholder="Sélectionnez le type de local"
      ></b-form-select>
    </b-form-group>

    <!-- Hauteur sous plafond -->
    <b-form-group label="Hauteur sous plafond ou sous faîtage du local (en m, ≥5)">
      <b-form-input
        type="number"
        v-model="systeme_destratification_airData.hauteur_sous_plafond"
        min="5"
        step="0.01"
      ></b-form-input>
    </b-form-group>

    <!-- Système de déstratification -->
    <b-form-group label="Système de déstratification d’air à écoulement">
      <b-form-select
        v-model="systeme_destratification_airData.ecoulement"
        :options="ecoulementOptions"
        placeholder="Sélectionnez le type d’écoulement"
      ></b-form-select>
    </b-form-group>

    <!-- Vitesse selon l'écoulement -->
    <b-form-group v-if="systeme_destratification_airData.ecoulement">
      <b-form-radio-group
        v-model="systeme_destratification_airData.vitesse"
        :options="ouiNonOptions"
        name="vitesse"
        stacked
      >
        <template #first>
          {{ systeme_destratification_airData.ecoulement === 'vertical' 
             ? 'La vitesse minimale de 0,1 m/s et maximale de 0,3 m/s au sol :'
             : 'La vitesse minimale de 0,01 m/s et maximale de 0,3 m/s en tout point du local :' }}
        </template>
      </b-form-radio-group>
    </b-form-group>

    <!-- Type de chauffage -->
    <b-form-group label="Type de chauffage">
      <b-form-select
        v-model="systeme_destratification_airData.chauffage"
        :options="chauffageOptions"
        placeholder="Sélectionnez le type de chauffage"
      ></b-form-select>
    </b-form-group>

    <!-- Champ aspiration vertical / horizontal selon chauffage -->
 <b-form-group v-if="systeme_destratification_airData.chauffage === 'convectif' || systeme_destratification_airData.chauffage === 'both'">
  <!-- Pour écoulement vertical -->
  <b-form-group 
    v-if="systeme_destratification_airData.ecoulement === 'vertical'" 
    label="L’aspiration de l’air s’effectue à au plus un mètre du plafond :">
    <div class="d-flex gap-3">
      <b-form-radio 
        v-model="systeme_destratification_airData.vertical_aspiration" 
        :value="true" 
        name="verticalAspiration">
        Oui
      </b-form-radio>
      <b-form-radio 
        v-model="systeme_destratification_airData.vertical_aspiration" 
        :value="false" 
        name="verticalAspiration">
        Non
      </b-form-radio>
    </div>
  </b-form-group>

  <!-- Pour écoulement horizontal -->
  <div v-if="systeme_destratification_airData.ecoulement === 'horizontal'">
    <!-- Point le plus haut -->
    <b-form-group label="Le point le plus haut de l’aspiration se situe à au plus un mètre du plafond :">
      <div class="d-flex gap-3">
        <b-form-radio 
        v-model="systeme_destratification_airData.horizontal_aspiration_haut" 
          :value="true" 
          name="horizontalAspirationHaut">
          Oui
        </b-form-radio>
        <b-form-radio 
        v-model="systeme_destratification_airData.horizontal_aspiration_haut" 
          :value="false" 
          name="horizontalAspirationHaut">
          Non
        </b-form-radio>
      </div>
    </b-form-group>

    <!-- Point le plus bas -->
    <b-form-group label="Le point le plus bas de l’aspiration se situe à au plus un mètre du sol :">
      <div class="d-flex gap-3">
        <b-form-radio 
        v-model="systeme_destratification_airData.horizontal_aspiration_bas" 
          :value="true" 
          name="horizontalAspirationBas">
          Oui
        </b-form-radio>
        <b-form-radio 
        v-model="systeme_destratification_airData.horizontal_aspiration_bas" 
          :value="false" 
          name="horizontalAspirationBas">
          Non
        </b-form-radio>
      </div>
    </b-form-group>
  </div>
</b-form-group>


    <!-- Mesure de température -->
<b-form-group label="Le système de déstratification d’air est asservi à une mesure de température de l’air entre le déstratificateur et le plafond">
  <div class="d-flex gap-3">
    <b-form-radio 
      v-model="systeme_destratification_airData.mesure_temperature" 
      :value="true" 
      name="mesureTemperature">
      Oui
    </b-form-radio>
    <b-form-radio 
      v-model="systeme_destratification_airData.mesure_temperature" 
      :value="false" 
      name="mesureTemperature">
      Non
    </b-form-radio>
  </div>
</b-form-group>


    <!-- Niveau de bruit -->
<b-form-group label="Le niveau du bruit au sol du fonctionnement du système est strictement inférieur à 45 dB">
  <div class="d-flex gap-3">
    <b-form-radio 
      v-model="systeme_destratification_airData.niveau_bruit" 
      :value="true" 
      name="niveauBruit">
      Oui
    </b-form-radio>
    <b-form-radio 
      v-model="systeme_destratification_airData.niveau_bruit" 
      :value="false" 
      name="niveauBruit">
      Non
    </b-form-radio>
  </div>
</b-form-group>




<b-form-group label="Le système de déstratification d’air installé ne permet pas de chauffer l’air">
  <div class="d-flex gap-3">
    <b-form-radio 
      v-model="systeme_destratification_airData.pas_de_chauffage" 
      :value="true" 
      name="pasDeChauffage">
      Oui
    </b-form-radio>
    <b-form-radio 
      v-model="systeme_destratification_airData.pas_de_chauffage" 
      :value="false" 
      name="pasDeChauffage">
      Non
    </b-form-radio>
  </div>
</b-form-group>


    <!-- Puissance chauffage convectif -->
    <b-form-group v-if="systeme_destratification_airData.chauffage === 'convectif' || systeme_destratification_airData.chauffage === 'both'" label="Puissance nominale du système de chauffage convectif du local (kW)">
      <b-form-input type="number" v-model="systeme_destratification_airData.puissance_convectif"></b-form-input>
    </b-form-group>

    <!-- Puissance chauffage radiatif -->
    <b-form-group v-if="systeme_destratification_airData.chauffage === 'radiatif' || systeme_destratification_airData.chauffage === 'both'" label="Puissance nominale du système de chauffage radiatif du local (kW)">
      <b-form-input type="number" v-model="systeme_destratification_airData.puissance_radiatif"></b-form-input>
    </b-form-group>

    <!-- Nombre de déstratificateurs -->
    <b-form-group label="Nombre de déstratificateurs d’air installés">
      <b-form-input type="number" v-model="systeme_destratification_airData.nombre_destratificateurs"></b-form-input>
    </b-form-group>



           </div>
  
          </form>
        
        </div>
        
      </div>
     
    </div>

    <div v-if="!show" class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import { handlePaste, preventExceedingLengthFloat } from "@/utils/inputUtils";
export default {
  components: {
    Snackbar,
  },
  props: {
    show: {
      type: Boolean,
      default:false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
    visibleTabsLength: {
      type: Number,
      required: true,
    },
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      systeme_destratification_airData: {
        id: null,
        local_type: "",
        hauteur_sous_plafond: "",
        ecoulement: "",
        vitesse: null,
        chauffage: "",
        vertical_aspiration: null,
        horizontal_aspiration_haut: null,
        horizontal_aspiration_bas: null,
        mesure_temperature: null,
        niveau_bruit: null,
        pas_de_chauffage: null,
        puissance_convectif: "",
        puissance_radiatif: "",
        nombre_destratificateurs: "",
      },
      systeme_destratification_air: false,
 localOptions: [
        { value: 'sport_transports', text: 'Local dédié aux activités sportives ou aux transports' },
        { value: 'commerce_spectacles_loisirs_culte', text: 'Local dédié au commerce, aux spectacles ou conférences, aux loisirs ou aux lieux de culte' }
      ],
      ecoulementOptions: [
        { value: 'vertical', text: 'Vertical' },
        { value: 'horizontal', text: 'Horizontal' }
      ],
      chauffageOptions: [
        { value: 'convectif', text: 'Convectif' },
        { value: 'radiatif', text: 'Radiatif' },
        { value: 'both', text: 'Convectif et Radiatif' }
      ],
      ouiNonOptions: [
        { value: true, text: 'Oui' },
        { value: false, text: 'Non' }
      ],
      isCompleted: false,
      errorMessage: "",
      isLoading: false,
    };
  },
  created() {
    if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
      this.systeme_destratification_airData =
        this.initializeSystemeDestratificationAir();
      this.systeme_destratification_air =
        this.getdevisMonoFiche.data?.devis?.systeme_destratification_air !== null;
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
    }),
    ...mapGetters(["getdevisMonoFiche"]),
    buttonText() {
      return this.visibleTabsLength <= 1 ? this.$t("NEXT") : this.$t("CONFIRMER");
    },
  },
  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          const currentData = this.systeme_destratification_airData
            ? { ...this.systeme_destratification_airData }
            : null;
          this.systeme_destratification_airData =
            this.initializeSystemeDestratificationAir();
          if (currentData) {
            const boolKeys = ['vitesse', 'vertical_aspiration', 'horizontal_aspiration_haut', 'horizontal_aspiration_bas', 'mesure_temperature', 'niveau_bruit', 'pas_de_chauffage'];
            Object.keys(currentData).forEach((key) => {
              if (
                currentData[key] !== undefined &&
                currentData[key] !== null &&
                currentData[key] !== ""
              ) {
                const val = boolKeys.includes(key) ? this.toBoolFromApi(currentData[key]) : currentData[key];
                this.systeme_destratification_airData[key] = val;
              }
            });
          }
          this.systeme_destratification_air =
            newDevis.data?.devis?.systeme_destratification_air !== null;
          if (this.systeme_destratification_air) {
            this.isCompleted = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["setDevisMonoFiche"]),

    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },

    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    async postSystemeDestratificationAir(payload) {
      try {
        const toNumericBool = (value) => {
          if (value === null || value === "") return null;
          if (typeof value === "boolean") return value ? 1 : 0;
          return Number(value);
        };
        const payloadWithNumericFields = {
          ...payload,
          vitesse: toNumericBool(payload.vitesse),
          vertical_aspiration: toNumericBool(payload.vertical_aspiration),
          horizontal_aspiration_haut: toNumericBool(payload.horizontal_aspiration_haut),
          horizontal_aspiration_bas: toNumericBool(payload.horizontal_aspiration_bas),
          mesure_temperature: toNumericBool(payload.mesure_temperature),
          niveau_bruit: toNumericBool(payload.niveau_bruit),
          pas_de_chauffage: toNumericBool(payload.pas_de_chauffage),
        };
        const response = await axios.post(
          domain + `/systeme_destratification_air`,
          payloadWithNumericFields,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );
        return response.data.data;
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.errorMessage = error.response.data.message;
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.errorMessage = error.response.data.errors.join(", ");
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },
    async putSystemeDestratificationAir(payload) {
      try {
        const toNumericBool = (value) => {
          if (value === null || value === "") return null;
          if (typeof value === "boolean") return value ? 1 : 0;
          return Number(value);
        };
        const payloadWithNumericFields = {
          ...payload,
          vitesse: toNumericBool(payload.vitesse),
          vertical_aspiration: toNumericBool(payload.vertical_aspiration),
          horizontal_aspiration_haut: toNumericBool(payload.horizontal_aspiration_haut),
          horizontal_aspiration_bas: toNumericBool(payload.horizontal_aspiration_bas),
          mesure_temperature: toNumericBool(payload.mesure_temperature),
          niveau_bruit: toNumericBool(payload.niveau_bruit),
          pas_de_chauffage: toNumericBool(payload.pas_de_chauffage),
        };
        const response = await axios.put(
          domain + `/systeme_destratification_air/${payload.id}`,
          payloadWithNumericFields,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );

        return response.data.data;
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.errorMessage = error.response.data.message;
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.errorMessage = error.response.data.errors.join(", ");
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },
    toBoolFromApi(value) {
      if (value === 1 || value === true) return true;
      if (value === 0 || value === false) return false;
      return null;
    },
    initializeSystemeDestratificationAir() {
      const systeme =
        this.getdevisMonoFiche?.data?.devis.systeme_destratification_air || {};

      return {
        id: systeme.id,
        local_type: systeme.local_type || "",
        hauteur_sous_plafond: systeme.hauteur_sous_plafond || "",
        ecoulement: systeme.ecoulement || "",
        vitesse: this.toBoolFromApi(systeme.vitesse),
        chauffage: systeme.chauffage || "",
        vertical_aspiration: this.toBoolFromApi(systeme.vertical_aspiration),
        horizontal_aspiration_haut: this.toBoolFromApi(systeme.horizontal_aspiration_haut),
        horizontal_aspiration_bas: this.toBoolFromApi(systeme.horizontal_aspiration_bas),
        mesure_temperature: this.toBoolFromApi(systeme.mesure_temperature),
        niveau_bruit: this.toBoolFromApi(systeme.niveau_bruit),
        pas_de_chauffage: this.toBoolFromApi(systeme.pas_de_chauffage),
        puissance_convectif: systeme.puissance_convectif || "",
        puissance_radiatif: systeme.puissance_radiatif || "",
        nombre_destratificateurs: systeme.nombre_destratificateurs || "",
      };
    },
    async systeme_destratification_airAdd() {
      const existingId =
        this.systeme_destratification_airData?.id ||
        this.getdevisMonoFiche?.data?.devis?.systeme_destratification_air?.id;
      if (this.systeme_destratification_air && existingId) {
        const chauffe = {
          ...this.systeme_destratification_airData,
          id: existingId,
        };

        const reponse = await this.putSystemeDestratificationAir(chauffe);
        if (!reponse) return;
        this.getdevisMonoFiche.data.devis.systeme_destratification_air = {
          id: existingId,
          ...this.systeme_destratification_airData,
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return reponse;
      }

      const response = await this.postSystemeDestratificationAir(
        this.systeme_destratification_airData
      );

      if (response && response.id !== null) {
        this.getdevisMonoFiche.data.devis.systeme_destratification_air_id =
          response.id;
        this.getdevisMonoFiche.data.devis.systeme_destratification_air = {
          id: response.id,
          ...this.systeme_destratification_airData,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return response;
      }
      this.isLoading = false;
      return;
    },
    async goToStep() {
      this.isLoading = true;
      this.isCompleted = false;
      if (!this.systeme_destratification_airData?.nombre_destratificateurs) {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar("Tous_obligatoires");
      }

      await this.systeme_destratification_airAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;

        return;
      }
   
      
      if(this.visibleTabsLength<=1){
        this.$emit("change",true);
      }
      this.isLoading = false;
      this.isCompleted = true;
    },
    async goToNextStep() {
      this.isLoading = true;
      if (!this.systeme_destratification_airData?.nombre_destratificateurs) {
        this.isLoading = false;
        this.$emit("changeStep", 5, true);
      }

      await this.systeme_destratification_airAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;

        return;
      }
      this.isLoading = false;
      this.$emit("changeStep", 5, true);
    },

    goToPrevStep() {
      if(this.visibleTabsLength<=1){
        this.$emit("changePrev",true);
      }else {
        this.$emit("changePrev",false);
      }
      this.$emit("changeStep", 3);
    },
  },
};
</script>
<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.input-style {
  margin-bottom: 1rem;
  border-radius: 4px;
  border: 1px solid #eaebec;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}

.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
